import React, { useEffect, useState } from "react";
import { FormikAsyncSearchComponent } from "../../../utilities/formUtils";
import { Field } from "formik";
import * as select from "../data/selectors";
import { useSelector } from "react-redux";
import { trim } from "lodash";
import { searchLedger } from "../data/actions";
import { setLedgersInEdit } from "../functions";
import { setAlertModalState } from "../../common/data/actions";

const LedgerSearch = (props) => {
    const {
        name,
        className,
        index,
        tabindex,
        placeholder,
        focus,
        isLabel,
        label,
        isTxn,
        isMandatory,
        isSelection,
        disabled,
        isEditMode,
        values,
        dispatch,
        componentType,
        cid,
        onBlurFunction,
        onFocusFunction,
        onKeyUpFunction,
        showLedgerCode,
        getValue: callback,
    } = props;

    const rawOptions = useSelector((state) => select.getSearchedResults(state, props));
    const options = showLedgerCode && Array.isArray(rawOptions)
        ? rawOptions.map((o) => {
            const displayText = o && o.ledgerName
                ? o.ledgerName + (o.ledgerCode ? " - " + o.ledgerCode : "")
                : (o && o.text) || "";
            return { ...o, text: displayText, title: displayText };
        })
        : rawOptions;
    const isFetching = useSelector((state) => select.getIsFetching(state, props));
    const [queryValue, setQueryValue] = useState("")

    const handleSearchChange = (e, data) => {
        let query = data.value;
        if (trim(query) && trim(query) !== undefined && trim(query) !== null && trim(query) !== "" && trim(query).length > 2) {
            if ('cid' in props && !cid) {
                dispatch(setAlertModalState({
                    isOpen: true,
                    type: "error",
                    size: "mini",
                    title: "Warning",
                    msg: "Please select a Company first before searching."
                }));
                return;
            }
            setQueryValue(query)
        }
    };

    useEffect(() => {
        if (trim(queryValue) && trim(queryValue) !== undefined && trim(queryValue) !== null && trim(queryValue) !== "" && trim(queryValue).length > 0) {
            let payload = {
                srchlName: trim(queryValue),
            }
            const timer = setTimeout(() => dispatch(searchLedger(payload, name, cid)), 500);
            return () => clearTimeout(timer);
        }
    }, [queryValue])

    useEffect(() => {
        if (isEditMode) {
            setLedgersInEdit(values, dispatch, componentType);
        }
    }, [isEditMode, componentType])

    const getInputValue = (e, setFieldValue, fieldName, obj, values, index) => {
        if (callback) {
            callback(e, values, setFieldValue, fieldName, obj, dispatch, index);
        }
    };

    const handleOnBlur = (e, setFieldValue, fieldName, obj, values, index) => {
        if (onBlurFunction) {
            onBlurFunction(e, values, setFieldValue, fieldName, obj, dispatch, index);
        }
    };

    const handleKeyUp = (e, setFieldValue, fieldName, values, index) => {
        if (onKeyUpFunction) {
            onKeyUpFunction(e, setFieldValue, fieldName, values, index);
        }
    };

    const handleFocus = (e, setFieldValue, fieldName, index) => {
        if (onFocusFunction) {
            onFocusFunction(e, setFieldValue, fieldName, index);
        }
    };

    const handleKeyDown = (e, setFieldValue, fieldName, values, index) => {

    }

    return (
        <Field
            name={name}
            component={FormikAsyncSearchComponent}
            handleSearchChange={handleSearchChange}
            tabindex={tabindex}
            userProps={{
                options,
                getInputValue,
                handleOnBlur,
                handleKeyUp,
                handleFocus,
                handleKeyDown,
            }}
            className={className}
            placeholder={placeholder}
            focus={focus ? focus : null}
            isLabel={isLabel}
            label={label}
            isTxn={isTxn}
            isSelection={isSelection}
            disabled={disabled}
            index={index}
            loading={isFetching}
            isMandatory={isMandatory}
        />
    );
};

export default LedgerSearch